import React from "react";
import BathtubIcon from "@assets/svg/Bath.svg?react";
import BedroomIcon from "@assets/svg/Bed.svg?react";
import UserIcon from "@assets/svg/UserIcon.svg?react";
import LineIcon from "@assets/svg/LineIcon.svg?react";
import useBreakPoinst from "@hooks/useBreakPoinst";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import {
  Badge,
  BadgeText,
  MsoolIcon,
  DetailsContainer,
  ImageContainer,
  ContentContainer,
  MainTitle,
  FeaturesContainer,
  FeatureItem,
  DateContainer,
  DateItem,
  DateLabel,
  DateValue,
  DateSubtext,
  LineIconContainer,
  PaymentContainer,
  PaymentTitle,
  PaymentRow,
  PaymentLabel,
  PaymentValue,
  PaymentTotal,
  GuestPortalDetailsIconStyled,
  GuestPortalDetailsDivider,
  GuestPortalDetailsDateDivider,
  GuestPortalDetailsPaymentDivider,
  ButtonContainer,
  StyledBox,
  ButtonText,
  ButtonAmount,
} from "./styles";
import { useWelcomeBook } from "@services";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import LoadingWrapper from "../../components/LoadingWrapper";
const GuestPortalSummary = () => {
  const { isPhone } = useBreakPoinst();
  const { id } = useParams();
  const navigate = useNavigate();
  const { GetWelcomeBookQuery, SaveReservationTransactionLogMutation } =
    useWelcomeBook();
  const { data } = GetWelcomeBookQuery(id ?? "");
  const result = data?.data?.result;

  // Call the function to get the mutation hook
  const { mutate, isPending } = SaveReservationTransactionLogMutation();
  const handlePayment = () => {
    mutate(id ?? "", {
      onSuccess: (response) => {
        navigate(`/guest/checkout/${id}/${response?.data?.result}`);
      },
    });
  };
  // Set Arabic locale for Day.js
  dayjs.locale("ar");

  // Format dates for Arabic display
  const formatArabicDate = (dateString: string) => {
    if (!dateString) return "";
    return dayjs(dateString).format("D MMMM");
  };
  if (result?.shouldUserPay == false) {
    return <Navigate to={`/guest/${id}`} />;
  }

  return (
    <LoadingWrapper style={{ zIndex: 1111 }} loading={isPending}>
      <DetailsContainer>
        {/* Image section  */}
        <ImageContainer $isPhone={isPhone}>
          {/* <GuestPortalDetailsIconStyled /> */}
          <img src={result?.image[0]} alt="property" />
        </ImageContainer>
        {/* Text section  */}
        <ContentContainer $isPhone={isPhone}>
          {/* title part  */}
          <MainTitle $isPhone={isPhone}>{result?.propertyName}</MainTitle>
          {/* text icon part  */}
          <FeaturesContainer $isPhone={isPhone}>
            <FeatureItem $isPhone={isPhone}>
              <BathtubIcon />
              {result?.bathroomCount} حمامات
            </FeatureItem>
            <FeatureItem $isPhone={isPhone}>
              <BedroomIcon />
              {result?.bedCount} أسرّة
            </FeatureItem>
            <FeatureItem $isPhone={isPhone}>
              <UserIcon />
              {result?.guestCount} ضيوف
            </FeatureItem>
          </FeaturesContainer>
          <GuestPortalDetailsDivider />
          {/* register departure and leave part  */}
          <DateContainer $isPhone={isPhone}>
            <DateItem $isPhone={isPhone}>
              <DateLabel $isPhone={isPhone}>تسجيل الدخول</DateLabel>
              <DateValue $isPhone={isPhone}>
                {formatArabicDate(result?.checkInDate)}
              </DateValue>
              <DateSubtext $isPhone={isPhone}>
                {result?.checkInDate}
              </DateSubtext>
            </DateItem>
            {/* Icon between arrive and leave  */}
            <LineIconContainer>
              <LineIcon width={!isPhone ? 200 : 80} />
            </LineIconContainer>
            <DateItem $isPhone={isPhone}>
              <DateLabel $isPhone={isPhone}>تسجيل الخروج</DateLabel>
              <DateValue $isPhone={isPhone}>
                {formatArabicDate(result?.checkOutDate)}
              </DateValue>
              <DateSubtext $isPhone={isPhone}>
                {result?.checkOutDate}
              </DateSubtext>
            </DateItem>
          </DateContainer>
          <GuestPortalDetailsDateDivider />
          {/* payment part  */}
          <PaymentContainer $isPhone={isPhone}>
            <PaymentTitle $isPhone={isPhone}>بيانات الدفع</PaymentTitle>
            <PaymentRow>
              <PaymentLabel $isPhone={isPhone}>
                {result?.numberOfNights} ليالي
              </PaymentLabel>

              <PaymentValue $isPhone={isPhone}>
                {" "}
                {result?.totalPrice} ريال
              </PaymentValue>
            </PaymentRow>
            <GuestPortalDetailsPaymentDivider />
            <PaymentRow>
              <PaymentTotal $isPhone={isPhone}>
                السعر الإجمالي للحجز
              </PaymentTotal>
              <PaymentTotal $isPhone={isPhone}>
                {result?.totalPrice} ريال
              </PaymentTotal>
            </PaymentRow>
          </PaymentContainer>
        </ContentContainer>

        {result?.paymentStatus !== "Passed" && (
          <ButtonContainer>
            <StyledBox onClick={handlePayment}>
              <ButtonText>ادفع الان</ButtonText>
              <ButtonAmount>{result?.totalPrice} ريال</ButtonAmount>
            </StyledBox>
          </ButtonContainer>
        )}
        <Badge $isPhone={isPhone}>
          <BadgeText $isPhone={isPhone}>مشغل بواسطة مسؤول</BadgeText>
          <MsoolIcon $isPhone={isPhone} />
        </Badge>
      </DetailsContainer>
    </LoadingWrapper>
  );
};

export default GuestPortalSummary;
